import { useQuery } from "react-query";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
type paramProps = { searchValue: string; pageNumber: number; size: number };

const getAllInvestorsPendingDocuments = async ({
  searchValue,
  pageNumber,
  size,
}: any) => {
  let queryParams = `?page=${pageNumber}&pageSize=${size}`;
  if(searchValue){
      queryParams = `${queryParams}&queryValue=${searchValue}`;
  }
    const { data } = await getDataWithDotNet(
      `${ajaxEndpoints.PENDING_INVESTORS_DOCUMENTS}${queryParams}`
    );
  return data;
};

export default function useAllInvestorsPendingDocuments({
  searchValue,
  pageNumber,
  size,
}: paramProps) {
  return useQuery(
    [{ searchValue, pageNumber, size }, "getAllInvestorsPendingDocuments"],
    getAllInvestorsPendingDocuments,
    {
      refetchOnWindowFocus: false,
    }
  );
}
